'use client';

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './games.css'; // Assuming this is your global CSS
import PointTable from './pointtable';

const FixturesAndResults = () => {
  return (
    <section id="results">
      <Container>
        <Row className="justify-content-center game-box">
          <Col xs={12} md={8} lg={6} className="column-padding">
            <PointTable />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FixturesAndResults;
